export const CyBeamer = {
  LyricsContent: "LyricsContent",
  FullscreenButton: "FullscreenButton",
} as const;
